module.exports = __webpack_public_path__ + "static/media/register.49b54380.jpeg";